var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 8.8H8.8V15.2C8.8 15.4122 8.71571 15.6157 8.56569 15.7657C8.41566 15.9157 8.21217 16 8 16C7.78783 16 7.58434 15.9157 7.43431 15.7657C7.28429 15.6157 7.2 15.4122 7.2 15.2V8.8H0.8C0.587827 8.8 0.384344 8.71571 0.234314 8.56569C0.0842853 8.41566 0 8.21217 0 8C0 7.78783 0.0842853 7.58434 0.234314 7.43431C0.384344 7.28429 0.587827 7.2 0.8 7.2H7.2V0.8C7.2 0.694943 7.22069 0.590914 7.2609 0.493853C7.3011 0.396793 7.36003 0.308601 7.43431 0.234314C7.5086 0.160028 7.59679 0.1011 7.69385 0.0608964C7.79091 0.0206926 7.89494 0 8 0C8.10506 0 8.20909 0.0206926 8.30615 0.0608964C8.40321 0.1011 8.4914 0.160028 8.56569 0.234314C8.63997 0.308601 8.6989 0.396793 8.7391 0.493853C8.77931 0.590914 8.8 0.694943 8.8 0.8V7.2H15.2C15.4122 7.2 15.6157 7.28429 15.7657 7.43431C15.9157 7.58434 16 7.78783 16 8C16 8.21217 15.9157 8.41566 15.7657 8.56569C15.6157 8.71571 15.4122 8.8 15.2 8.8Z",
    fill: "#005BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.4b39256bd6adbc85a0939e2051ed1d1c.svg";
export { ForwardRef as ReactComponent };